<template>
  <div
    class="vote"
    :style="{ backgroundImage: 'url(' + moduleIconUrl + ')' }"
  >
    <div class="header">
      <div class="header_info">
        <span
          class="header_title"
          :style="{ textShadow: `0px 2px 8px ${buttonColor}` }"
          >{{ componentConfig?.title }}</span
        >
        <span
          class="header_desc"
          :style="{ textShadow: `0px 2px 8px ${buttonColor}` }"
          >{{ componentConfig?.subtitle }}</span
        >
      </div>
    </div>
    <div
      class="content sensors_exposure"
      sensorsname="VoteModuleExposure"
      :sensorsdata="
        JSON.stringify({
          moduleName: `${componentConfig.sort}|${componentConfig.type}`,
          contentName: `${componentConfig?.title}`,
        })
      "
    >
      <Empty
        v-if="!loading && !voteTitle && voteList?.length === 0"
        text="暂无投票信息"
      />
      <div v-else>
        <div class="votetitle">{{ voteTitle }}</div>
        <!--单选-->
        <div class="voteOps" v-show="isSingleChoice">
          <div
            :class="{
              voteOpsItem: true,
              singleChoiceSelected: isVoted && item.selected,
            }"
            v-for="(item, index) in voteList"
            :key="index"
            @click="handleVote(item)"
            v-show="item.isShow"
          >
            <div
              v-show="isVoted"
              class="selectedAnimation"
              :style="{ width: (item.ups / optionTotalUps) * 100 + '%' }"
            >
              <div
                v-show="!noAnimation"
                :class="{
                  dh: true,
                  selectedDh: item.selected,
                  unSelectedDh: !item.selected,
                }"
              ></div>
              <div
                v-show="noAnimation"
                :class="{
                  votedDh: true,
                  selectedDh: item.selected,
                  unSelectedDh: !item.selected,
                }"
              ></div>
            </div>
            <div class="opstext">
              <span class="text">{{ item.title }}</span>
              <span
                class="selectedIcon"
                v-show="isVoted && item.selected"
              ></span>
            </div>
            <div class="num" v-show="isVoted">{{ item.ups }}</div>
          </div>
        </div>
        <!--多选-->
        <div class="voteOps" v-show="!isSingleChoice">
          <div
            :class="{
              voteOpsItem: true,
              selected: !isVoted && choiceIdList.includes(item.id),
              mulitChoiceSelected: isVoted && choiceIdList.includes(item.id),
            }"
            v-for="(item, index) in voteList"
            :key="index"
            @click="handleVotesOpt(item)"
            v-show="item.isShow"
          >
            <div
              v-show="isVoted"
              class="selectedAnimation"
              :style="{ width: (item.ups / optionTotalUps) * 100 + '%' }"
            >
              <div
                v-show="!noAnimation"
                :class="{
                  dh: true,
                  selectedDh: item.selected,
                  unSelectedDh: !item.selected,
                }"
              ></div>
              <div
                v-show="noAnimation"
                :class="{
                  votedDh: true,
                  selectedDh: item.selected,
                  unSelectedDh: !item.selected,
                }"
              ></div>
            </div>
            <div class="opstext">
              <span class="text">{{ item.title }}</span>
              <span
                class="selectedIcon"
                v-show="isVoted && item.selected"
              ></span>
            </div>
            <div class="num" v-show="isVoted">{{ item.ups }}</div>
          </div>
        </div>
        <!--查看全部选项-->
        <div
          class="viewAllOpt"
          v-show="voteList.length > 4 && isShowViewAllBtn"
          @click="viewAllOpt"
        >
          <div class="allOptBox">
            <span>查看全部选项</span>
            <span class="viewAllIcon"></span>
          </div>
        </div>
        <div
          class="packup"
          v-show="voteList.length > 4 && !isShowViewAllBtn"
          @click="packUp"
        >
          <span>收起</span>
          <span class="packupIcon"></span>
        </div>
        <div class="voteinfo">
          <span>{{ isSingleChoice ? "[单选]" : "[多选]" }}</span>
          <span>{{ optionTotalUps }}人参与，</span>
          <span>投票后结果可见</span>
        </div>
        <div
          v-show="
            !isSingleChoice &&
            ((choiceIdList.length > 0 && !isShowViewAllBtn) ||
              (isVoted && !isShowViewAllBtn))
          "
          :class="{ votesBtn: true, votedBtn: isVoted }"
          @click="handleVotes"
        >
          {{ isVoted ? "投票成功" : "投票" }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Empty from "../common/EmptyData.vue";
export default {
  name: "VoteMod",
  components: { Empty },
  props: {
    pageConfig: {
      type: Object,
      default: () => {},
    },
    componentConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      optionTotalUps: 0,
      isSingleChoice: false, // 是否为单选
      voteList: [],
      isVoted: false, // 是否投递
      choiceIdList: [], // 多选选中列表id
      isShowViewAllBtn: false,
      noAnimation: false, //从展开过来
      optionSelectMax: 0, // 最多选几个
      loading: true,
      voteTitle: "", //投票标题
      voteId: "", //投票id
    };
  },
  computed: {
    ...mapState(["commonStore","resumeStore"]),
    backgroundConfigDTO(){
      return this.componentConfig.backgroundConfigDTO
    },
    buttonColor(){
      return this.backgroundConfigDTO?.buttonColor||this.pageConfig.buttonColor
    },
    moduleIconUrl(){
      if(this.commonStore.isForPC){
        return this.backgroundConfigDTO?.moduleIconPcUrl||this.pageConfig.moduleIconPcUrl
      }else{
        return this.backgroundConfigDTO?.moduleIconUrl||this.pageConfig.moduleIconUrl
      }
    },
  },
  watch: {},
  created() {
    this.getVoteInfo();
  },
  methods: {
    getVoteInfo() {
      let params = {
        componentId: this.componentConfig.id,
      };
      this.$api.activity.voteListQuery(params).then((res) => {
        this.loading = false;
        if (res?.code == "0") {
          this.voteTitle = res.data.description;
          this.isSingleChoice = res.data.optionSelectMax == "1" ? true : false;
          this.optionSelectMax = res.data.optionSelectMax;
          this.isVoted = res.data.optionSelected;
          this.voteList = res.data?.options ? res.data?.options : [];
          this.optionTotalUps = res.data.optionTotalUps;
          this.voteId = res.data.id;
          if (this.voteList.length > 0) {
            this.handleVoteList();
          }
          // 已投票 无动画
          if (this.isVoted) {
            this.noAnimation = true;
            // 筛选已投票选项
            this.voteList.filter((item) => {
              if (item.selected) {
                this.choiceIdList.push(item.id);
              }
            });
          }
        }
      });
    },
    // 问题选项超过4个，隐藏展示
    handleVoteList() {
      if (this.voteList.length > 4) {
        this.isShowViewAllBtn = true;
        this.voteList.forEach((item, index) => {
          if (index > 3) {
            item.isShow = false;
          } else {
            item.isShow = true;
          }
        });
      } else {
        this.isShowViewAllBtn = false;
        this.voteList.forEach((item) => {
          item.isShow = true;
        });
      }
    },
    // 查看全部选项
    viewAllOpt() {
      this.isShowViewAllBtn = false;
      this.voteList.forEach((item) => {
        item.isShow = true;
      });
    },
    // 收起
    packUp() {
      this.handleVoteList();
      // 多选选中后未投票收起清空选中
      if (!this.isSingleChoice) {
        this.choiceIdList = [];
      }
    },
    // 单选投票
    handleVote(data) {
      if (this.$base.checkLoginStatus(true)) {
        if (!this.isVoted) {
          this.$sensors.track("$WebClick", {
            $element_id: "sensor_bcop_vote",
            moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
            contentName: `${this.componentConfig?.title}`,
          });
          let optionIdsArray = [];
          optionIdsArray.push(data.id);
          let params = {
            id: this.voteId,
            optionIds: optionIdsArray,
          };
          this.$api.activity
            .voteSubmit(params)
            .then((res) => {
              if (res?.code == "0") {
                this.optionTotalUps++;
                this.isVoted = true;
                data.ups++;
                setTimeout(() => {
                  this.noAnimation = true;
                }, 500);
                console.log(data, "单选投票成功");
                this.voteList.find((i) => i.id === data.id).selected = true;
              } else {
                this.$toast(res.msg);
              }
            })
            .catch((err) => {
              this.$toast(err.msg);
            });
        } else {
          this.$toast("已投票，不能重复投票");
        }
      }
    },
    // 多选投票
    handleVotes() {
      if (this.isVoted) {
        this.$toast("已投票，不能重复投票");
        return;
      }
      if (this.choiceIdList.length == 0) {
        this.$toast("请选择至少一项进行投票");
      } else {
        this.$sensors.track("$WebClick", {
          $element_id: "sensor_bcop_vote",
          moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
          contentName: `${this.componentConfig?.title}`,
        });
        let params = {
          id: this.voteId,
          optionIds: this.choiceIdList,
        };
        this.$api.activity
          .voteSubmit(params)
          .then((res) => {
            if (res?.code == "0") {
              this.optionTotalUps++;
              this.isVoted = true;
              setTimeout(() => {
                this.noAnimation = true;
              }, 500);
              this.voteList.forEach((i) => {
                if (this.choiceIdList.includes(i.id)) {
                  i.selected = true;
                }
              });
            } else {
              this.$toast(res.msg);
            }
          })
          .catch((err) => {
            this.$toast(err.msg);
          });
      }
    },
    handleVotesOpt(data) {
      if (this.$base.checkLoginStatus(true)) {
        if (this.isVoted) {
          this.$toast("已投票，不能重复投票");
          return;
        }

        let currentId = data.id;
        if (!this.choiceIdList.includes(currentId)) {
          // 添加最多可投票限制
          if (this.choiceIdList.length >= this.optionSelectMax) {
            this.$toast(`最多可选${this.optionSelectMax}项进行投票`);
            return;
          }
          this.choiceIdList = [...this.choiceIdList, currentId];
          data.ups++;
        } else {
          this.choiceIdList = this.choiceIdList.filter((item) => {
            return item !== data.id;
          });
          data.ups--;
        }
      }
    },
  },
};
</script>
<style scoped lang="less">
.vote {
  width: 100%;
  box-sizing: border-box;
  border-radius: 12px 12px 0px 0px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% auto;
  position: relative;
  padding-bottom: 24px;
  .adapt_pc_widescreen & {
    width: 1200px;
    margin: 0 auto;
  }
  .header {
    display: flex;
    align-items: baseline;
    padding: 13px 8px 4px 8px;
    justify-content: space-between;
    .header_info {
      .header_title {
        width: 98px;
        font-size: 20px;
        font-weight: 600;
        color: #ffffff;
        line-height: 30px;
        text-shadow: 0px 2px 8px #e16e69;
        margin-left: 8px;
      }
      .header_desc {
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        text-shadow: 0px 2px 8px #e16e69;
        margin-left: 9px;
      }
    }
    .header_change {
      width: 74px;
      height: 25px;
      // background: #f96440;
      border-radius: 13px;
      color: #ffffff;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      // margin-left: 19px;
      line-height: 25px;
      .icon {
        width: 16px;
        height: 16px;
        background: url("@/assets/img/activity/change@3x.png");
        background-size: cover;
      }
      .change {
        margin-left: 2px;
      }
    }
  }
  .content {
    border-radius: 8px;
    margin: 6px 8px;
    // padding-bottom: 4px;
    padding: 10px;
    overflow: hidden;
    font-size: 12px;
    background: #ffffff;
    position: relative;
    .votetitle {
      width: 100%;
      font-size: 14px;
      font-weight: 600;
      color: #222222;
    }

    .voteinfo {
      width: 100%;
      height: 30px;
      display: flex;
      line-height: 30px;
      font-size: 12px;
      color: #7c7f87;
    }
    .voteOps {
      .voteOpsItem {
        width: 100%;
        height: 36px;
        border: 1px solid #d0d0d0;
        line-height: 36px;
        margin: 6px 0;
        border-radius: 5px;
        padding: 0 8px;
        font-size: 14px;
        color: #4e525a;
        display: flex;
        justify-content: space-between;
        position: relative;
        overflow: hidden;
        .selectedAnimation {
          height: 34px;
          position: absolute;
          left: 0;
          top: 0;
          font-weight: 500;
          .dh {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            animation: grow 0.35s linear;
          }
          .votedDh {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
          .selectedDh {
            background: #ffe7dc;
          }
          .unSelectedDh {
            background: #ededed;
          }
        }
        .opstext {
          z-index: 1;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .text {
            max-width: 280px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .selectedIcon {
            width: 18px;
            height: 14px;
            background: url("@/assets/img/activity/selected2.png");
            background-size: cover;
            margin-left: 4px;
          }
        }
        .num {
          font-weight: 500;
          z-index: 2;
        }
      }
      .singleChoiceSelected {
        border: 1px solid #ff6c0e;
        color: #ff6c0e;
      }
      .mulitChoiceSelected {
        border: 1px solid #ff6c0e;
        color: #ff6c0e;
      }
      .selected {
        border: 2px solid #ff8b40;
        color: #ff6c0e;
        background-image: url("@/assets/img/activity/selected1.png");
        background-position: 100% 0;
        background-repeat: no-repeat;
        background-size: 15px 15px;
      }
    }
    .viewAllOpt {
      width: 100%;
      font-weight: 400;
      font-size: 14px;
      color: #ff6c0e;
      position: absolute;
      left: 0;
      z-index: 2;
      top: 125px;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0) 50%,
        rgba(255, 255, 255, 1) 95%,
        #ffffff 100%
      );
      height: 202px;
      top: 10px;
      left: 0;
      .allOptBox {
        margin-top: 183px;
        display: flex;
        align-items: center;
        justify-content: center;
        .viewAllIcon {
          width: 8px;
          height: 4px;
          background: url("@/assets/img/activity/tobottom.png");
          background-size: cover;
          margin-left: 6px;
        }
      }
    }
    .packup {
      width: 100%;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border-radius: 3px;
      font-weight: 400;
      font-size: 14px;
      color: #ff6c0e;
      display: flex;
      align-items: center;
      justify-content: center;
      .packupIcon {
        width: 7px;
        height: 4px;
        background: url("@/assets/img/activity/totop.png");
        background-size: cover;
        margin-left: 6px;
      }
    }
    .votesBtn {
      width: 198px;
      height: 34px;
      box-sizing: content-box;
      background: linear-gradient(180deg, #ffbd65 0%, #ff6332 100%);
      box-shadow: inset 0px 1px 0px 0px #ffd99c, inset 0px -1px 5px 0px #ffb843;
      border: 1px solid rgb(255, 99, 50);
      margin: 0 auto;
      border-radius: 18px;
      // opacity: 0.7;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 34px;
    }
    .votedBtn {
      border: 0;
      border: 1px solid rgba(255, 99, 50, 0.8);
      opacity: 0.6;
    }
  }
}
@keyframes grow {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
</style>
